import loginBackground from './backgroundLogin.webp';
import backgroundLoginCapitalmarkets from './backgroundLoginCapitalmarkets.webp';

export const images = { loginBackground, backgroundLoginCapitalmarkets };
